package com.loyola.acessoescola.services.adminpanel

class UpdateLogException(
    message: String,
    cause: Throwable? = null
): Exception(message, cause)